export enum SidebarMode {
  DEFAULT = 'DEFAULT',
  CREATE = 'CREATE',
}
